import GenericTracker from "./generic-tracker";
import { DataEvent } from "./global-event";

export default class DataTracker extends GenericTracker {
    constructor () {
        super();
    }

    track(event: DataEvent) {
        window.tracker.track(event.libelle, {
            "p": event.p ? event.p : false,
            "url": event.p ? event.url : false,
            "iid": event.p ? event.iid : false,
            "it": event.p ? event.it : false
        });
    }
}